import React, { useState } from 'react';
import NavbarLogo from './NavbarLogo';
import NavbarLinks from './NavbarLinks';
import AuthButton from './AuthButton';
import useNavbarScroll from '../../hooks/useNavbarScroll';

export default function Navbar() {
  const { activeSection, handleScroll } = useNavbarScroll();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const linkClass = (section) =>
    `px-4 py-2 rounded-lg transition-colors duration-200 ease-in-out select-none focus:outline-none font-medium ${
      activeSection === section ? 'bg-secondary text-surface' : 'text-bodyText hover:text-secondary'
    }`;

  const handleMobileClose = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className="bg-primaryBg shadow-md py-3 px-3 md:py-4 md:px-8 fixed top-0 left-0 right-0 z-50 w-full">
      {/* Desktop Navigation */}
      <div className="hidden md:flex justify-between items-center">
        <NavbarLogo onClick={() => handleScroll('hero')} />
        <div className="flex space-x-4 items-center">
          <NavbarLinks
            activeSection={activeSection}
            handleScroll={handleScroll}
            linkClass={linkClass}
          />
          <AuthButton />
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className="md:hidden flex justify-between items-center h-14">
        {/* Mobile Menu Button (Left) - 4 horizontal lines */}
        <button
          className="flex flex-col justify-center items-center text-bodyText hover:text-secondary transition h-full w-14 -ml-1"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? (
            // X icon when menu is open
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            // 4 horizontal lines when menu is closed
            <div className="space-y-1.5">
              <div className="w-5 h-0.5 bg-bodyText rounded"></div>
              <div className="w-5 h-0.5 bg-bodyText rounded"></div>
              <div className="w-5 h-0.5 bg-bodyText rounded"></div>
              <div className="w-5 h-0.5 bg-bodyText rounded"></div>
            </div>
          )}
        </button>

        {/* Logo (Center) */}
        <div className="flex-1 flex justify-center px-2">
          <NavbarLogo onClick={() => handleScroll('hero')} sizeClass="h-10 md:h-12" />
        </div>

        {/* Auth Button (Right) - Compact version for mobile */}
        <div className="h-full w-14 flex items-center justify-center -mr-1">
          <AuthButton isMobileCompact={true} />
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="md:hidden mt-4 border-t border-secondary pt-4">
          <div className="flex flex-col space-y-2">
            <NavbarLinks
              activeSection={activeSection}
              handleScroll={handleScroll}
              linkClass={linkClass}
              isMobile={true}
              onClose={handleMobileClose}
            />
          </div>
        </div>
      )}
    </nav>
  );
}
